"use client";

import { Provider } from "react-redux";
import { store } from "./store";
import AdminProvider from "@/middleware/AdminProvider";

export function Providers({ children }: { children: React.ReactNode }) {

  return (
    <Provider store={store}>
      <AdminProvider>{children}</AdminProvider>
    </Provider>
  );
}
